export default __webpack_public_path__ + "static/media/logo-dark-mode.3b415760.png";